/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProviderCode {
    BaNdc = 'BaNdc',
    Travelport = 'Travelport',
    TravelportNdc = 'TravelportNdc',
    EkNdc = 'EkNdc',
    EkNative = 'EkNative',
    Paxport = 'Paxport',
    EasyJet = 'EasyJet'
}

export function ProviderCodeFromJSON(json: any): ProviderCode {
    return ProviderCodeFromJSONTyped(json, false);
}

export function ProviderCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCode {
    return json as ProviderCode;
}

export function ProviderCodeToJSON(value?: ProviderCode | null): any {
    return value as any;
}

